import Vue from 'vue'
import App from './App.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VueSilentbox from 'vue-silentbox'
import {VueMasonryPlugin} from 'vue-masonry'
import WOW from 'wow.js/dist/wow.js'
import VueMeta from 'vue-meta'
import axios from 'axios'


import 'bootstrap/dist/css/bootstrap.css'
import '../src/assets/css/fontawesome-all.min.css'
import 'swiper/dist/css/swiper.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'slick-carousel/slick/slick.css'
import { routes } from './router/index'



// const scrollBehavior = function (to) {
//     if (to.hash) {
//       return {
//         // 通过 to.hash 的值來找到对应的元素
//         selector: to.hash
//       }
//     }
// }

const router = new VueRouter({
    routes,
    mode: 'history',
    // scrollBehavior
})

axios.defaults.baseURL = (location.href.indexOf('stage.creis.jp')>-1?'https://api2.creis.jp':'https://api.creis.jp')+'/api/v1/research';//process.env.VUE_APP_API_URL_BASE
  axios.defaults.withCredentials = true
  var initlan=async function init_language(){
    var upd=localStorage.getItem('creis_web_lan_updated_at');
    upd=upd==undefined || upd=='undefined' || upd==null || upd=='' ?'2021-01-01':upd;
    var response = await axios.get('getCreisWebLanguage',{params:{updated_at:upd, token:localStorage.getItem('id_token')} })
    if(upd<response.data.last_updated_at || localStorage.getItem('creis_web_language_data')==null || localStorage.getItem('creis_web_language_data')==''){
       
        localStorage.setItem('creis_web_lan_updated_at',response.data.last_updated_at); 
        let lan_data=JSON.stringify(response.data) 
        localStorage.setItem('creis_web_language_data',lan_data);
        
    }
    
    Vue.use(VueMasonryPlugin)
    Vue.use(VueSilentbox)
    Vue.use(VueRouter)
    Vue.use(BootstrapVue)
    Vue.use(VueAwesomeSwiper)
    Vue.use(VueMeta, {
        refreshOnceOnNavigation: true
    })

    Vue.config.productionTip = false
    Vue.config.productionSourceMap = false


    new Vue({
        render: h => h(App),
        router,
        mounted(){
            new WOW().init();
        }
    }).$mount('#app')
}
initlan();
